import { render, staticRenderFns } from "./four-side-css-props.vue?vue&type=template&id=b578073a&scoped=true&"
import script from "./four-side-css-props.vue?vue&type=script&lang=js&"
export * from "./four-side-css-props.vue?vue&type=script&lang=js&"
import style0 from "./four-side-css-props.vue?vue&type=style&index=0&id=b578073a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b578073a",
  null
  
)

export default component.exports